import * as fromQuestions from './questions/getters';
import * as fromOfferings from './offerings/getters';
import * as fromContributors from './contributors/getters';
import * as fromOverlay from './overlay/getters';
import * as fromEvents from './events/getters';
import * as fromProjects from './projects/getters';
import * as fromLayout from './layout/getters';

export default {
    ...fromQuestions.default,
    ...fromOfferings.default,
    ...fromContributors.default,
    ...fromOverlay.default,
    ...fromEvents.default,
    ...fromProjects.default,
    ...fromLayout.default,
};
